import { AmagiAPIClient } from '@amagimedia/api-client';
import { APP_BASE_DOMAIN, BACKEND_API_URL_V3 } from './constants';

export const amagiAPIClientStvV2 = new AmagiAPIClient(
  BACKEND_API_URL_V3!,
  APP_BASE_DOMAIN!,
);

export const ApiClientStvV2 = amagiAPIClientStvV2.createApiClient({
  withCredentials: false,
});
